export default class LoginModel {
    constructor(
        public userIdentity?: string,
        public password?: string,
		public sessionId?: string,
        public captchaToken?: string,
        public userIpAddress?: string,
    ) {}
}